import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export function Error() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('A apărut o eroare');

  useEffect(() => {
    const reason = searchParams.get('reason');
    
    switch (reason) {
      case 'invalid_token':
        setMessage('Link-ul de autentificare este invalid sau a fost manipulat.');
        break;
      case 'expired_or_used':
        setMessage('Link-ul a expirat sau a fost deja folosit. Link-urile sunt valide 15 minute și pot fi folosite o singură dată.');
        break;
      case 'inactive':
        setMessage('Contul este inactiv. Contactează parteneriate@institutulbrainmap.ro pentru asistență.');
        break;
      case 'not_found':
        setMessage('Utilizatorul nu a fost găsit.');
        break;
      default:
        setMessage('A apărut o eroare la autentificare. Încearcă din nou.');
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <h1 className="text-2xl font-serif text-red-600 mb-4">Eroare</h1>
        <p className="text-muted mb-6">{message}</p>
        <button
          onClick={() => navigate('/auth/login')}
          className="w-full py-3 px-4 bg-teal text-white font-medium rounded-lg hover:bg-teal-light transition-colors"
        >
          Înapoi la login
        </button>
      </div>
    </div>
  );
}
